import { RTL_LANGUAGES } from "@flights/constants";
export default function isRTL(language) {
    return RTL_LANGUAGES.includes(language);
}
